import { getProductFormField } from '../utils';
import Component from './ProductFormCard';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
